var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Badge, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';
const FilterButton = (props) => {
    const { children, active, onClick, endIcon, badgeContent } = props, rest = __rest(props, ["children", "active", "onClick", "endIcon", "badgeContent"]);
    return (React.createElement(Button, Object.assign({ variant: 'contained', endIcon: React.createElement(React.Fragment, null,
            endIcon,
            !!badgeContent && (React.createElement(Badge, { color: 'primary', badgeContent: badgeContent, sx: () => ({
                    padding: 0,
                    transform: 'none',
                    '.BaseBadge-badge': {
                        position: 'relative',
                        fontSize: '10px',
                        minWidth: '16px',
                        height: '16px',
                        padding: 0,
                        transform: 'none',
                    },
                    ' .MuiBadge-badge': {
                        height: '14px',
                        minWidth: '14px',
                        fontSize: '12px',
                        padding: '0',
                    },
                }) }))), onClick: onClick, disableElevation: true, sx: (theme) => (Object.assign({ position: 'relative', minWidth: 'auto', color: theme.palette.text.secondary, padding: '6px 6px', height: '100%', bgcolor: 'background.default', borderWidth: '0', borderStyle: 'solid', borderColor: theme.palette.divider, span: {
                margin: theme.spacing(0),
            }, path: {
                fill: theme.palette.text.secondary,
            }, '&:hover, &.active': {
                bgcolor: 'background.default',
            }, '&.Mui-disabled': {
                bgcolor: alpha(theme.palette.text.secondary, 0.05),
            } }, (active && {
            color: theme.palette.primary.main + '!important',
            bgcolor: alpha(theme.palette.primary.main, 0.12) + '!important',
            borderColor: alpha(theme.palette.primary.main, 0.12),
            path: {
                fill: theme.palette.primary.main,
            },
        }))) }, rest), children));
};
export default FilterButton;
